import { createBrowserRouter } from "react-router-dom";
import {
  ROUTES_DEFAULT,
  ROUTES_FORBIDDEN,
  ROUTES_HOME,
  ROUTES_PATIENT,
  ROUTES_PATIENTS,
  ROUTES_SEARCH_OMIM,
} from "./utils/constants";
import NotFoundPage from "./components/not-found-page/NotFoundPage";
import React from "react";
import LandingComponent from "./components/landing/LandingComponent";
import App from "./App";
import SearchOmimComponent from "./components/searchOminComponent/SearchOmimComponent";
import PatientComponent from "./components/patientComponent/PatientComponent";
import PatientsComponent from "./components/patientsComponent/PatientsComponent";

export const GENOME_ROUTES = createBrowserRouter([
  {
    path: ROUTES_HOME,
    element: <App />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: ROUTES_HOME,
        element: <LandingComponent />,
      },
      {
        path: ROUTES_SEARCH_OMIM,
        element: <SearchOmimComponent />,
      },
      {
        path: ROUTES_PATIENTS,
        element: <PatientsComponent />,
      },
      {
        path: ROUTES_PATIENT,
        element: <PatientComponent />,
      },
      {
        path: ROUTES_FORBIDDEN,
        element: <NotFoundPage />,
      },
      {
        path: ROUTES_DEFAULT,
        element: <NotFoundPage />,
      },
    ],
  },
]);
